import { Link, useLocation, useParams } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { CheckCircle2, Copy, ArrowRight, Search } from "lucide-react";
import { toast } from "sonner";
import { LOGO_URL } from "@/lib/constants";

const Confirmation = () => {
  const { ref } = useParams();
  const { state } = useLocation();
  const job = state?.job;

  const copyRef = async () => {
    await navigator.clipboard.writeText(ref);
    toast.success("Reference copied");
  };

  return (
    <div className="min-h-screen bg-spark-floor">
      <Navbar />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-20" data-testid="confirmation-page">
        <div className="surface-card p-8 sm:p-12 relative overflow-hidden">
          <img src={LOGO_URL} alt="" aria-hidden className="absolute -top-10 -right-10 size-48 opacity-10 rotate-12" />
          <div className="relative">
            <div className="size-14 rounded-full bg-spark-teal text-white flex items-center justify-center mb-6">
              <CheckCircle2 className="size-7" />
            </div>
            <p className="label-mono text-spark-teal mb-2">Booking received</p>
            <h1 className="font-display uppercase tracking-tight text-4xl sm:text-5xl font-bold mb-4">
              Thanks{job?.full_name ? `, ${job.full_name.split(" ")[0]}` : ""} — we got it.
            </h1>
            <p className="text-spark-slate mb-8 leading-relaxed">
              We've logged your repair request. Save the reference below — you'll use it to track progress on the workstage tracker. We'll be in touch shortly to confirm the drop-off.
            </p>

            <div className="bg-spark-teal-deep text-white rounded-md p-5 sm:p-6 flex items-center justify-between gap-4 mb-8">
              <div>
                <p className="label-mono text-spark-yellow mb-1">Your reference</p>
                <p className="font-display uppercase tracking-wider text-2xl sm:text-3xl font-bold" data-testid="confirmation-ref">{ref}</p>
              </div>
              <button onClick={copyRef} className="btn-outline-ink !border-white !text-white hover:!bg-white hover:!text-spark-ink" data-testid="copy-ref-btn">
                <Copy className="size-4" /> Copy
              </button>
            </div>

            {job && (
              <dl className="grid sm:grid-cols-2 gap-x-8 gap-y-4 mb-10 text-sm">
                <div>
                  <dt className="label-mono mb-1">Scooter</dt>
                  <dd>{job.scooter_brand} {job.scooter_model}</dd>
                </div>
                <div>
                  <dt className="label-mono mb-1">Service</dt>
                  <dd className="capitalize">{job.service_type}</dd>
                </div>
                <div>
                  <dt className="label-mono mb-1">{job.pickup_required ? "Pickup time" : "Drop-off"}</dt>
                  <dd>{new Date(job.preferred_dropoff_at).toLocaleString("en-NZ", { dateStyle: "medium", timeStyle: "short" })}</dd>
                </div>
                <div>
                  <dt className="label-mono mb-1">Urgency</dt>
                  <dd className="capitalize">{job.urgency}</dd>
                </div>
              </dl>
            )}

            <div className="flex flex-wrap gap-3">
              <Link to={`/track?reference=${ref}`} className="btn-primary" data-testid="confirmation-track-btn">
                <Search className="size-4" /> Track this job
              </Link>
              <Link to="/" className="btn-outline-ink" data-testid="confirmation-home-btn">
                Back to home <ArrowRight className="size-4" />
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Confirmation;
